export const perferredDetails = ({ BeURL, formData, currentUser, navigate, reverse, previous }) => {

    fetch(`${BeURL}/perferredinfromation`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ BeURL, formData })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                alert(data.message)
                if (reverse)
                    navigate(previous)
                else
                    navigate(`/update-account/success?userId=${currentUser?._id}`)
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.log('Error in Login:', err)
            alert('Trouble in connecting to the Server! Please try again later.')
        })

}
